import {EntityKey} from './entity-key';

export class EntityHeader {

  id!: EntityKey;
  approvalStatus!: string;
  associatedEntityId!: string;
  associatedEntityRevision!: number;
  awardProbabilityPercent!: number;
  colorCode!: string;
  contractTypeDescription!: string;
  createTimestamp!: Date;
  createUser!: string;
  customer!: string;
  currentPhase!: string;
  entityId!: string;
  externalNotes!: string;
  finalExtendedAmount!: number;
  includeInForecastIndicator!: boolean;
  internalNotes!: string;
  lastStatusChangeDate!: Date;
  leadTime!: string;
  levelOfReportingCode!: string;
  locationCity!: string;
  locationState!: string;
  locationZip!: string;
  numericUserField4!: number;
  outsideSalesRep!: string;
  outsideSalesRepPhone!: string;
  poNumber!: string;
  priorityCode!: string;
  projectName!: string;
  recordCount!: number;
  region!: string;
  responsibility!: string;
  responsibilityPhone!: string;
  salesRep!: string;
  sellingOrgUnitID!: string;
  smallTextUserField1!: string;
  smallTextUserField3!: string;
  statusDescription!: string;
  statusCode!: string;
  totalUnitQty!: number;
  updateTimestamp!: string;
  updateUser!: string;

}
